import type { PriorAuthorizationAttachmentT } from '@lotushealth/lotushealth_js_sdk/schemas';

export function countClinicianUploads(
  attachments: PriorAuthorizationAttachmentT[] | null | undefined
): number {
  return (attachments ?? []).filter((attachment) => attachment.IsOutbound === true).length;
}
